import * as React from 'react';
import { StatusBadge } from '../../../ui';

const DOMAIN_VARIANT = {
  staffing: 'staffing',
  quality:  'quality',
  access:   'access',
  finance:  'finance',
  consumer: 'consumer',
  health:   'health',
};

const DOMAIN_LABEL = {
  staffing: 'Staffing',
  quality:  'Quality',
  access:   'Access',
  finance:  'Finance',
  consumer: 'Consumer',
  health:   'Pop Health',
};

function DomainBadge({ domain, size = 'sm', className }) {
  return (
    <StatusBadge
      variant={DOMAIN_VARIANT[domain] ?? 'info'}
      size={size}
      className={className}
    >
      {DOMAIN_LABEL[domain] ?? domain}
    </StatusBadge>
  );
}

export { DomainBadge };
